module.exports = __webpack_public_path__ + "images/sichuan_banner03.jpg?38dc6b7a6a8c2c8d05f4544247022abd";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/sichuan_banner03.jpg
// module id = 194
// module chunks = 1